<template>
  <div class="as-footStats-info" v-if="footyStats">
    <div class="as-footStats__info">
      <FootballTeamItem
        :match="match"
        mode="info"
        :footyStats="footyStats"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
      <div class="as-vs">VS</div>
      <FootballTeamItem
        :match="match"
        :footyStats="footyStats"
        modeTeam="as-away"
        mode="info"
        :homePoint="homePoint"
        :awayPoint="awayPoint"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "~src/components/foot_stats/FootballTeamItem.vue";
import type { IFootyStats } from "~src/interfaces/footystats";

interface Props {
  match: IMatch;
  footyStats: IFootyStats | null;
}

const props = withDefaults(defineProps<Props>(), {
  footyStats: null,
});

const homePoint = computed<number>(() => {
  return props.footyStats?.pre_match_home_ppg ?? 0;
});

const awayPoint = computed<number>(() => {
  return props.footyStats?.pre_match_away_ppg ?? 0;
});
</script>

<script lang="ts">
export default {};
</script>
